import { z } from 'zod';

import {
  ProfileTemplatePermissionSchema,
  ProfileTemplateScopeTypeSchema,
} from './shared.schemas.js';

export const GetProfileTemplateResponseSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  scopeType: ProfileTemplateScopeTypeSchema,
  active: z.boolean(),
  permissions: z.array(ProfileTemplatePermissionSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type GetProfileTemplateResponse = z.infer<typeof GetProfileTemplateResponseSchema>;
